import { iMonitor } from './monitor';

(() => {
  // JS异常
  window.addEventListener('error', (err) => {
    try {
      const errorMessage = encodeURIComponent(err?.message || '');
      iMonitor.logEvent('JSError', {
        errorMessage,
      });
    } catch (_err) {
      console.log(_err);
    }
  });
  // Promise异常
  window.addEventListener('unhandledrejection', (err) => {
    try {
      const errorMessage = encodeURIComponent(err?.reason || '');
      iMonitor.logEvent('unhandledrejection', {
        errorMessage,
      });
    } catch (_err) {
      console.log(_err);
    }
  });
})();
